export enum Rules {
  minLength = 'minLength',
  maxLength = 'maxLength',
  uppercase = 'uppercase',
  lowercase = 'lowercase',
  digit = 'digit',
  specialChar = 'specialChar',
  noForbiddenChar = 'noForbiddenChar',
}

export interface ValidationResult {
  valid: boolean;
  message?: string;
}

export interface RulesResponse {
  [Rules.minLength]: ValidationResult;
  [Rules.maxLength]: ValidationResult;
  [Rules.uppercase]: ValidationResult;
  [Rules.lowercase]: ValidationResult;
  [Rules.digit]: ValidationResult;
  [Rules.specialChar]: ValidationResult;
  [Rules.noForbiddenChar]: ValidationResult;
}

export interface ValidationResponse {
  isPasswordValid: boolean;
  rules: RulesResponse;
}
